export default () => ({
  entity: 'document',
  entities: 'documents',
  currentEntity: {},
  documents: [],
  errors: {
  },
  document: {
    document_status_id: null,
    document_status: null,
    extension: null,
    filename: null,
    label: null,
    name: null,
    required: null,
    slug: null,
    validity: null
  },
    // never use prefix v1.
  prefixRouter: 'professional.documents'
})



// WEBPACK FOOTER //
// ./src/app/professional/documents/resources/data.js